import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { AlertTriangle } from 'lucide-react'

interface ExpiredOrderModalProps {
  isOpen: boolean
  onClose: () => void
}

export function ExpiredOrderModal({ isOpen, onClose }: ExpiredOrderModalProps) {
  const { t } = useTranslation('common')
  const router = useRouter()

  const handleConfirm = () => {
    onClose()

    if (router.pathname.startsWith('app')) {
    } else {
    }
    window.location.reload()
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-yellow-500" />
            {t('order_expired')}
          </DialogTitle>
          <DialogDescription>
            {t('order_expired_description')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={handleConfirm}>{t('confirm')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
